"use client";

import { useEffect, useState } from "react";
import { FiAlertTriangle } from "react-icons/fi";

interface ErrorAlertProps {
  title: string;
  message: string;
  onClose: () => void;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ title, message, onClose }) => {
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setClosing(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (closing) {
      const timer = setTimeout(() => {
        onClose();
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [closing, onClose]);

  return (
    <div
      role="alert"
      aria-live="assertive"
      className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-500 ${
        closing
          ? "opacity-0 pointer-events-none"
          : "opacity-100 backdrop-blur-sm"
      }`}
    >
      <div
        className={`relative bg-[var(--color-background-card)] text-[var(--color-error)] px-8 py-6 rounded-3xl shadow-2xl border-4 border-[var(--color-error)] max-w-md w-full mx-4 flex flex-col items-center gap-4 transform transition-all duration-500 ${
          closing
            ? "-translate-y-20 opacity-0 scale-95"
            : "translate-y-0 opacity-100 scale-100 animate-slideUp"
        }`}
      >
        {/* Ícono */}
        <div className="flex items-center justify-center bg-[var(--color-error)] text-[var(--color-text-inverse)] w-20 h-20 rounded-full shadow-md">
          <FiAlertTriangle className="w-12 h-12" />
        </div>

        <p className="text-2xl font-bold text-center">{title}</p>

        <div className="text-xl text-[var(--color-text-primary)] text-center space-y-1">
          <p>{message}</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorAlert;
